import { store, deleteCategory } from "$lib/store.svelte";

function apiEndpoint(path)
{
    return import.meta.env.VITE_API_ENDPOINT + '/' + path;
}

export async function fetchTranslations(fetch)
{
    let url = apiEndpoint('translations');
    return fetch(url).then((res) => res.json());
}

export async function fetchLanguages(fetch)
{
    let url = apiEndpoint('languages');
    return fetch(url).then((res) => res.json());
}

export async function fetchCategories(fetch)
{
    let url = apiEndpoint('categories');
    return fetch(url).then((res) => res.json());
}

export async function fetchPlaces(fetch)
{
    let url = apiEndpoint('places');
    return fetch(url).then((res) => res.json());
}

function categorySeek(categories, searched_id)
{
    let ret = null;

    categories.every((category, index) => {
        if (category.id == searched_id) {
            ret = category;
            return false;
        }
        else {
            if (category.children.length > 0) {
                ret = categorySeek(category.children, searched_id);
                if (ret) {
                    return false;
                }
            }
        }

        return true;
    });

    return ret;
}

function categorySeekAndReplace(categories, searched)
{
    let done = false;

    categories.every((category, index) => {
        if (category.id == searched.id) {
            categories.splice(index, 1, searched);
            done = true;
            return false;
        }
        else {
            if (category.children.length > 0) {
                done = categorySeekAndReplace(category.children, searched);
                if (done) {
                    return false;
                }
            }
        }

        return true;
    });

    return done;
}

export async function pushCategory(category)
{
    let url = apiEndpoint('categories');

    fetch(url, {
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(category)
    }).then((res) => res.json()).then((saved) => {
        if (category.id == null) {
            if (saved.parent) {
                parent = categorySeek(store.categories, saved.parent);
                parent.children.push(saved);
            }
            else {
                store.categories.push(saved);
            }
        }
        else {
            categorySeekAndReplace(store.categories, saved);
        }
    });
}

export async function convertCategory(category)
{
    let url = apiEndpoint('category/convert');

    category.parent = category.parent?.id;

    fetch(url, {
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(category)
    }).then((res) => res.json()).then((saved) => {
        deleteCategory(store.categories, category);
        store.places.push(saved);
    });
}

export async function pushLanguage(language)
{
    let url = apiEndpoint('languages');

    fetch(url, {
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(language)
    }).then((res) => res.json()).then((saved) => {
        if (language.id == null) {
            store.languages.push(saved);
        }
        else {
            let index = store.languages.findIndex((c) => c.id == language.id);
            store.languages.splice(index, 1, saved);
        }
    });
}

export async function pushPlace(place)
{
    let url = apiEndpoint('places');

    fetch(url, {
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(place)
    }).then((res) => res.json()).then((saved) => {
        if (place.id == null) {
            store.places.push(saved);
        }
        else {
            let index = store.places.findIndex((c) => c.id == place.id);
            store.places.splice(index, 1, saved);
        }
    });
}

export async function deletePlace(place)
{
    let url = apiEndpoint('places');

    fetch(url, {
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'DELETE',
        body: JSON.stringify(place)
    }).then((res) => res.json()).then((deleted) => {
        let index = store.places.findIndex((c) => c.id == deleted.id);
        store.places.splice(index, 1);
    });
}
